import {setAttributes} from '../../utils/iterators/setAttributes';

export const initCopyButton = () => {
	const copyButtons = document.querySelectorAll( 'span.copy[data-copy]' );

	if ( !copyButtons.length )
	{
		return;
	}

	Array.from( copyButtons ).forEach( ( it ) => {
		it.addEventListener( 'click', () => {
			const temporaryInput = document.createElement( 'input' );
	
			setAttributes( temporaryInput, {
				type: 'text',
				name: 'link',
				value: it.dataset.copy,
			} );
	
			it.appendChild( temporaryInput );
			temporaryInput.select();
			document.execCommand( 'copy' );
			it.removeChild( temporaryInput );
			it.classList.add( 'success' );
	
			const CLASS_TIMEOUT = setTimeout( () => {
				it.classList.remove( 'success' );
				clearTimeout( CLASS_TIMEOUT );
			}, 700 );
		} );
	} );
};
